import {DashboardSalesStatus, DashboardSummary} from "@/features/dashboard";
// import {useGetEmployeeMe} from "@/shared/api";
import {vars} from "@/shared/lib/theme.css";
import {Column, Indicator} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";
import {Suspense} from "react";

export const Route = createFileRoute("/(auth)/_layout/")({
	component: MainScreen
});

// const AVAILABLE_DEPARTMENTS = ["영업본부 전체", "1영업부", "2영업부", "3영업부", "4영업부", "5영업부"];

function MainScreen() {
	// const {data: meData} = useGetEmployeeMe();
	// const department = meData.department;

	return (
		<Column fullWidth style={{gap: vars.size[32]}}>
			<DashboardSummary />
			{/* {AVAILABLE_DEPARTMENTS.includes(department) && ( */}
			<Suspense fallback={<Indicator />}>
				<DashboardSalesStatus />
			</Suspense>
			{/* )} */}
		</Column>
	);
}
